import { useTranslation } from "react-i18next";

// حقل اسم المستلم للرابط العام — قابل للتحرير عند غياب الاسم المخزَّن، مقفول عند وجوده.
export const PublicBillNameInput = ({ value, setValue, locked }) => {
  const { t } = useTranslation();
  return (
    <div className="rounded-2xl border-2 border-emerald-200 bg-white p-4">
      <p className="mb-2 flex items-center gap-2 text-sm font-black text-emerald-700">
        👤 {t("acct.bills.mysign.receiverName")}
      </p>
      {locked ? (
        <div className="rounded-xl border-2 border-emerald-300 bg-emerald-50 p-3">
          <p className="text-center text-lg font-black text-emerald-900" data-testid="my-receiver-name">
            {value || "—"}
          </p>
        </div>
      ) : (
        <input type="text" value={value} onChange={(e) => setValue(e.target.value)}
               data-testid="public-name-input"
               placeholder={t("acct.bills.sign.namePh")}
               className="w-full rounded-xl border-2 border-emerald-300 bg-white p-3 text-center text-lg font-black text-emerald-900 focus:border-emerald-500 focus:outline-none" />
      )}
      <p className="mt-2 text-center text-[11px] text-muted-foreground">
        {locked ? t("acct.bills.mysign.nameAuto") : t("acct.bills.sign.namePh")}
      </p>
    </div>
  );
};
